import React from 'react';
import EmptyListUI from '../../../widgets/output/EmptyListUI';
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI';
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI';
import CardUI from '../../../widgets/layout/CardUI';
import { Link } from 'react-router-dom';
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI';
import IconButtonUI from '../../../widgets/action/IconButtonUI';

const JournalEntriesListPageUI = ({
    context, errorList, journalDTOList, onPushClick, onRefreshClick
}) =>
    <SuperUserAccountPageUI context={context} className='pg_su_acc' backLink='/su/accounts'
        headerText='Journal Entries' dimension='w768'
        centered={!errorList || !journalDTOList} page='journalEntries'
    >
        {
            (!errorList || !journalDTOList) &&
            <SpinnerComponentUI />
        }
        {
            journalDTOList &&
            <LRTableActionsUI location='top'
                left={
                    <span className='g_flex_left g_flex_h'>
                        <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
                        <span className='g_m_left_100 g_large'><b>Journal Entries</b></span>
                    </span>
                }
                right={<span />}
            />
        }
        {
            journalDTOList && journalDTOList.length === 0 &&
            <EmptyListUI context={context} createDisabledMessageLabel='No Journal Entries' />
        }
        {
            journalDTOList && journalDTOList.length > 0 &&
            <JournalEntriesUI journalDTOList={journalDTOList} onPushClick={onPushClick} />
        }
    </SuperUserAccountPageUI>

const JournalEntriesUI = ({ journalDTOList, onPushClick }) =>
    <div>
        <CardUI title='Journal Entries' className='g_m_top_100'>
            <table>
                <tbody style={{ width: '140px', fontSize: '12px' }} >
                    <tr className='g_flex_h'>
                        <th style={{ marginLeft: '20px' }}>Date</th>
                        <th style={{ width: '140px', marginLeft: '30px' }}>GL Account Id</th>
                        <th style={{ width: '120px' }}>Credit</th>
                        <th style={{ width: '140px' }}>Debit</th>
                        <th style={{ width: '140px' }}>Description</th>   
                        <td style={{ marginLeft: '50px'}}></td>
                    </tr>
                    {
                        journalDTOList.map((journal, i) =>
                            <div className='g_flex_h'>
                                <CardUI className='g_m_top_50'>
                                    <tr className='acc' key={i}>
                                        <td style={{  marginLeft: '20px' }}>{journal.journalDate}</td>
                                        <td style={{ width: '140px' }}>{journal.transactionList[1].chartOfAccountId}</td>
                                        <td style={{ width: '140px' }}>{journal.transactionList[1].credit}</td>
                                        <td></td>
                                        <td style={{ width: '140px' }}>{journal.description}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '140px' }}>{journal.journalDate}</td>
                                        <td style={{ width: '140px' }}>{journal.transactionList[0].chartOfAccountId}</td>
                                        <td ></td>
                                        <td style={{ width: '140px' }}>{journal.transactionList[0].debit}</td>
                                        <td style={{ width: '140px' }}>{journal.description}</td>
                                    </tr>
                                </CardUI>
                                {
                                    !journal.syncedWithZybra &&
                                    <Link onClick={onPushClick} data-journal-id={journal.journalId} to='#' style={{ marginLeft: '10px' }}>Push to Zybra</Link>
                                }
                            </div>
                        )
                    }
                </tbody>
            </table>
        </CardUI>
    </div>

export default JournalEntriesListPageUI